/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { faSquareFacebook, faSquareTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';

import { useSelector, useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import { getAllPicks } from '../../redux/features/picks/picks';

import { setPicks } from '../../redux/features/picks/picksSlice';

import store from '../../redux/store';

const styles = () => ({
  drawer: {
    position: 'fixed',
    top: '13px',
    right: -290,
    width: 230,
    // height: '20vh',
    background: '#fff',
    zIndex: 5,
    transition: 'all .6s ease',
    boxShadow: '0 1px 3px rgba(0,0,0,.175)',
    border: '1px solid rgba(0,0,0,.15)',
    color: '#00247E',
    fontSize: '14px',
  },
  closing: {
    textAlign: 'right',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 10,
  },
  close: {
    width: 15,
    height: 15,
    // padding: '0 10px',
  },
  button: {
    padding: '15px 17px 14px',
    '& a': {
      textDecoration: 'none',
      color: '#00247E',
    },
  },
  buttonSelected: {
    padding: '15px 17px 14px',
    color: '#666',
  },
  clear: {
    padding: '15px 17px 14px',
    // borderBottom: '1px solid lightgray',
  },
  gray: {
    background: '#f4f5f0',
    padding: '15px 17px 14px',
  },
  socialicons: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'nowrap',
  },
});

const Drawer = ({
  classes,
  isOpen,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const nodeRef = useRef(null);

  const pickz = useSelector((state) => getAllPicks(state));

  const handleClick = (event) => {
    const outsideClick = !nodeRef.current.contains(event.target);

    if (outsideClick) {
      handleClose();
    }
  };

  const handleKeyUp = (event) => {
    if (event.keyCode === 27) { handleClose(event); }
  };

  useEffect(() => {
    window.addEventListener('click', handleClick);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('click', handleClick);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  // Picks
  const pickForMe = () => {
    const teams = Object.values(store.getState().teams);
    const groups = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    const randomChance = () => ((Math.random() * 0.2) - 0.15);
    groups.forEach((group) => {
      const first = teams
        .filter((team) => team.group === group)
        .reduce((a, b) => ((Number(a.endfirst) || 0) + randomChance() > (Number(b.endfirst) || 0) + randomChance() ? a : b)); // eslint-disable-line max-len
      const second = teams
        .filter((team) => team.group === group && team.id !== first.id)
        .reduce((a, b) => ((Number(a.endfirst) || 0) + (Number(a.endsecond) || 0) + randomChance() > (Number(b.endfirst) || 0) + (Number(b.endsecond) || 0) + randomChance() ? a : b)); // eslint-disable-line max-len
      const picks = [{ id: `${group}1`, teamId: first.id }, { id: `${group}2`, teamId: second.id }];
      dispatch(setPicks(picks));
    });
  };

  const startOver = () => {
    const groups = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    groups.forEach((group) => {
      const picks = [{ id: `${group}1`, teamId: null }, { id: `${group}2`, teamId: null }];
      dispatch(setPicks(picks));
    });
  };

  const handleCopy = () => {
    const url = `${window.location.href.split('#')[0]}#/?${Object.values(pickz).reduce((string, pick) => `${string}${pick.id}=${pick.teamId},`, '')}`;
    const el = document.createElement('input');
    el.setAttribute('type', 'text');
    el.setAttribute('value', url);
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    el.remove();
    alert('copied to clipboard'); // eslint-disable-line no-alert
  };

  const handleShare = async (platform) => {
    const tab = window.open('about:blank');
    const url = `${window.location.href.split('#')[0]}#/?${Object.values(pickz).reduce((string, pick) => `${string}${pick.id}=${pick.teamId},`, '')}`;
    const res = await fetch(`https://api-ssl.bitly.com/v3/shorten?access_token=7ef8fe7360e7ca2f25c6d65fcc7e4bf7f11038ff&longUrl=${encodeURIComponent(url)}`);
    const resJSON = await res.json();
    const shareUrl = resJSON.data.url;

    if (platform === 'facebook') {
      tab.location.href = `http://www.facebook.com/share.php?u=${shareUrl}`;
    } else if (platform === 'twitter') {
      tab.location.href = `https://twitter.com/intent/tweet?text=Check+out+my+Qlik+2022+World+Cup+Bracket&url=${shareUrl}&hashtags=Qlik,WC2022`;
    } else if (platform === 'linkedin') {
      tab.location.href = `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=Check%20out%20my%202022%20World%20Cup%20Bracket&summary=Check%20out%20my%20World%20Cup%20bracket%20in%20Qlik’s%20Choose%20Your%20Champion%202022%20app&source=Qlik%20Choose%20Your%20Champion`;
    }
  };

  return (
    <div
      className={classes.drawer}
      style={{ right: isOpen ? 9 : -290 }}
      ref={nodeRef}
    >
      <div className={classes.closing} onClick={() => handleClose()}>
        <img className={classes.close} src="assets/images/close.svg" alt="close" />
      </div>
      <div className={classes.buttonSelected}>Create a Bracket</div>
      <div className={classes.button}>
        <Link to="/historical-analysis">Historical Analysis</Link>
      </div>
      <div style={{ margin: '5px 0', height: 1, backgroundColor: 'lightgray' }} />

      <div className={classes.button} onClick={() => pickForMe()}>
        Autocomplete Group Stage
      </div>
      <div className={classes.clear} onClick={() => startOver()}>
        Start Over
      </div>
      <div className={classes.gray}>
        <div className={classes.item}>
          <div className={classes.socialicons}>
            <div className={classes.icon}>
              <a onClick={() => handleShare('facebook')}>
                <FontAwesomeIcon icon={faSquareFacebook} />
              </a>
            </div>
            <div className={classes.icon}>
              <a onClick={() => handleShare('twitter')}>
                <FontAwesomeIcon icon={faSquareTwitter} />
              </a>
            </div>
            <div className={classes.icon}>
              <a onClick={() => handleShare('linkedin')}>
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
            <div className={classes.icon}>
              <a onClick={() => handleCopy()}>
                <FontAwesomeIcon icon={faLink} />
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

Drawer.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default injectSheet(styles)(Drawer);
